// import axios from "axios";
import * as d3 from "d3";
import {
    colonAnnotation,
    createTooltip,
    DEFAULT_AXIS_FONT_SIZE,
    fw_progressive_1way,
    numberFormat
} from '../functions'

export default function (chart, divId, vizName,resData) {
    const defaultSize = true
    const defaultChartLayout = {
        width: 650,
        height: 650,
        margin: { top: 10, right: 20, bottom: 10, left: 20 }
    }
    const chartWidth = defaultSize ? defaultChartLayout.width : chart.width
    const chartHeight = defaultSize ? defaultChartLayout.height : chart.height
    const chartMargin = defaultSize ? defaultChartLayout.margin : chart.margin
    const axisFontSize = (defaultSize ? DEFAULT_AXIS_FONT_SIZE : chart.axisFontSize) + "px"

   // var url = '/api/fetchDataWithParam/' + chart.data.datasqlId + '/' + vizName;

    // axios.post(url, filterParam).then(res => {
        let data = resData;
        console.log(chart.y1MetricTooltip,chart.y2MetricTooltip)

        var renameKeys = function (obj) {
            /*Recursively renames "key" keys to "name" and
            renames "values" keys to "children" */
            obj.name = obj.key;
            delete obj.key;
            if (obj.values) {
                obj.children = obj.values;
                delete obj.values;
                obj.children.forEach(renameKeys);
            }
            return obj;
        };

        var nest = d3.nest()
            .key(function (d) { return d.dim1_name; })
            .sortKeys(d3.ascending)
            .key(function (d) { return d.dim3_name; })
            .sortKeys(d3.ascending)
            .key(function (d) { return d.dim2_name; })
            .sortKeys(d3.ascending)
            .rollup(function (v) {
                return {
                    metric1: d3.sum(v, d => d.metric1),
                    metric2: d3.sum(v, d => d.metric2)  // 👈 add metric2
                };
            })
            .entries(data);

        var flareData = { key: chart.y1AxisDisplayName, values: [] };
        flareData.values = nest;
        renameKeys(flareData);

        // Fixed chart dimensions
        const diameter = chartWidth;

        // Remove any existing SVG and append a new one
        d3.select(divId).select("svg").remove();
        const svg = d3.select(divId)
            .append("svg")
            .attr("width", chartWidth + chartMargin.left + chartMargin.right)
            .attr("height", chartHeight + chartMargin.top + chartMargin.bottom)
            .append("g")
            .attr("transform", "translate(" + chartWidth / 2 + ", " + (chartWidth / 2) + ")");

        var g = svg.append("g")
            .attr('transform', "translate(" + (chartMargin.left + chartMargin.right) / 2 + "," + (chartMargin.top + chartMargin.bottom) / 2 + ")");

        // Define color scales
        const metric1ColorScale = d3.scaleLinear()
            .domain([-1, 5])
            .range(["hsl(152,80%,80%)", "hsl(228,30%,40%)"])
            .interpolate(d3.interpolateHcl);

        const metric2ColorScale = d3.scaleOrdinal(fw_progressive_1way);

        // Create a D3 pack layout
        const pack = d3.pack()
            .size([diameter, diameter])
            .padding(0);

    const root = d3.hierarchy(flareData)
        .sum(d => d.value?.metric1)
        .sort((a, b) => b.value.metric1 - a.value.metric1);

        let focus = root;
        const nodes = pack(root).descendants();
        let view;

        // Tooltip setup
        const tooltip = createTooltip(divId);

        // Create circles
        const circle = g.selectAll("circle")
            .data(nodes)
            .enter()
            .append("circle")
            .attr("class", function (d) {
                return d.parent ? d.children ? "nodes" : "node node--leafcircle" : "node node--root";
            })
            .style("fill", function (d) {
                return d.children ? metric1ColorScale(d.depth) :
                    d.data.name.startsWith('1_C') ? "#00FF00" :
                        d.data.name.startsWith('2_P') ? '#90EE90' :
                            d.data.name.startsWith('3_L') ? "#FFFF00" :
                                d.data.name.startsWith('4_I') ? "#FF0000" : metric2ColorScale(d.data.name);
            })
            .on("click", function (d) {
                if (focus !== d) zoom(d), d3.event.stopPropagation();
            })
            .on('mouseover', function (d) {
                if (d.depth === 3) {
                    tooltip.onMouseOver(d, this, data =>
                        chart.x1MetricTooltip + colonAnnotation + data.data.name + "<br/>" +
                        chart.x2MetricTooltip + colonAnnotation + data.parent.data.name + "<br/>" +
                        chart.y1MetricTooltip + colonAnnotation + numberFormat(data.data.value.metric1) + "<br/>" +
                        chart.y2MetricTooltip + colonAnnotation + numberFormat(data.data.value.metric2)
                    );
                } else if (d.depth === 1 || d.depth === 0) {
                    tooltip.onMouseOver(d, this, data => data.data.name + colonAnnotation + numberFormat(data.value));
                }
            })
            .on('mousemove', tooltip.onMouseMove)
            .on('mouseleave', function () {
                tooltip.onMouseLeave(this);
            });

        g.selectAll("text")
            .data(nodes)
            .enter()
            .append("text")
            .attr("class", "labels")
            .style("display", (d) => {
                return d.parent === root ? "inline" : "none"
            })
            .text((d) => {
                return d.data.name
            });

        // Move the legend outside the SVG on the right side
        const legendContainer = d3.select(divId).append("div")
            .attr("class", "legend-container")
            .style("position", "absolute")
            .style("top", "60px") // Adjust this to your desired top position
            .style("right", "60px") // Use right instead of left for top-right positioning
            .style("margin", "auto")
            .style("height", "600px")
        .style("overflow", "auto")
            .style("width", "250px")   // 👈 fixed width
            .style("overflow", "auto")
            .style("word-wrap", "break-word")  // 👈 wrap long words
            .style("white-space", "normal")
            .style("text-align", "start");

    const legendItems = legendContainer.selectAll(".legendItem")
            .data(d3.nest()
                .key(function (d) { return d.dim2_name; })
                .entries(data))
            .enter()
            .append("div")
            .attr("class", "legendItem")
            .style("margin-bottom", "10px")
            .style("display", "flex")
            .style("align-items", "center");

        legendItems.append("div")
            .style("width", "12px")
            .style("height", "12px")
            .style("background-color", function (d) {
                return metric2ColorScale(d.key);
            })
            .style("margin-right", "5px");

        legendItems.append("span")
            .style("font-size", axisFontSize)
            .text(function (d) {
                return d.key;
            });

        var node = g.selectAll("circle,text");

        svg.style("background", metric1ColorScale(-1))
            .on("click", function () {
                zoom(root);
            });

        zoomTo([root.x, root.y, root.r * 2]);

        function zoom(d) {
            focus = d;

            const transition = d3.transition()
                .duration(750)
                .tween("zoom", function () {
                    const i = d3.interpolateZoom(view, [focus.x, focus.y, focus.r * 2]);
                    return t => zoomTo(i(t));
                });

            transition.selectAll("text")
                .filter(function (d) {
                    return d.parent === focus || this.style.display === "inline";
                })
                .style("fill-opacity", d => (d.parent === focus ? 1 : 0))
                .on("start", function (d) {
                    if (d.parent === focus) this.style.display = "inline";
                })
                .on("end", function (d) {
                    if (d.parent !== focus) this.style.display = "none";
                });
        }

        function zoomTo(v) {
            const k = diameter / v[2];
            view = v;
            node.attr("transform", d => `translate(${(d.x - v[0]) * k}, ${(d.y - v[1]) * k})`);
            circle.attr("r", d => d.r * k);
        }
    // });
}

